class PosNotification extends React.Component {

    render() {
        var notification = this.props.notification;

        if (notification.length < 1)
        	return null;

        var next = [];

        if (notification.length > 1) {
        	for (var i=1; i<notification.length; i++) {
        		next.push(notification[i])
        	}
        }

        return (
            <div className='popup popup__transparent'>
            	<div className='popup__content pos-notification'>
		            <div className='popup-header'>
		            	{notification[0].header}

	                    <div
	                        className='popup-close'
	                        onClick={() => { this.props.onClear(next); }}>

	                        <i className="fa fa-times" aria-hidden="true" />
	                    </div>
	                </div>

	                <div
	                	className='pos-notification__content'
	                	dangerouslySetInnerHTML={{ __html: notification[0].body.replace(/\n/g, "<br />") }} />

                </div>
            </div>
        );
    }
}

export default PosNotification;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/notification/PosNotification.react.jsx